export default [    
    {   name:'CollateralBuildIndex',
        route:'/CollateralBuilds'
    },
    {   name:'CollateralBuildDesign',
        route:'/CollateralBuilds/:collateralBuildId/Design'
    },
    {   name:'CollateralBuildCreate',
        route:'/CollateralBuilds/Create'
    },
    {   name:'ClientCollateralBuildIndex',
        route:'/Clients/:clientId/CollateralBuilds'
    },
    {   name:'ClientCollateralBuildCreate',
        route:'/Clients/:clientId/CollateralBuilds/Create'
    }
];